export default class LoginCommand {
  username: string
  password: string

  constructor() {
    this.username = ''
    this.password = ''
  }
}